import React, { createContext, useContext, useState, useEffect } from "react";
import { getCategories } from "../api/categoryApi";
import { getBrandsList, getBestDeals, getProducts } from "../api/productApi";

const GlobalDataContext = createContext();

export const useGlobalData = () => {
  const context = useContext(GlobalDataContext);
  if (!context) {
    throw new Error("useGlobalData must be used within a GlobalDataProvider");
  }
  return context;
};

export const GlobalDataProvider = ({ children }) => {
  const [categories, setCategories] = useState([]);
  const [categoriesLoading, setCategoriesLoading] = useState(true);

  const [brands, setBrands] = useState([]);
  const [brandsLoading, setBrandsLoading] = useState(true);

  const [bestDeals, setBestDeals] = useState([]);
  const [bestDealsVisible, setBestDealsVisible] = useState(true);
  const [bestDealsLoading, setBestDealsLoading] = useState(true);

  const [products, setProducts] = useState([]);
  const [productsLoading, setProductsLoading] = useState(true);

  useEffect(() => {
    const fetchAllData = async () => {
      // Fetch Categories
      getCategories({ isActive: true }).then((response) => {
        if (response.success && response.data?.categories) {
          const formatted = response.data.categories.map((cat) => ({
            name: cat.name,
            slug: cat.slug,
            id: cat._id || cat.id,
          }));
          setCategories(formatted);
        }
        setCategoriesLoading(false);
      }).catch((error) => {
        console.error("Error fetching categories:", error);
        setCategoriesLoading(false);
      });

      // Fetch Brands
      getBrandsList().then((response) => {
        if (response.success && Array.isArray(response.data)) {
          const formatted = response.data.map((brand) => ({
            id: brand._id,
            name: brand.name,
            logo: brand.logo || null,
            slug: brand.slug,
          }));
          setBrands(formatted);
        }
        setBrandsLoading(false);
      }).catch((error) => {
        console.error("Error fetching brands:", error);
        setBrandsLoading(false);
      });

      // Fetch Best Deals (Budget)
      getBestDeals().then((response) => {
        if (response.success && response.data) {
          if (response.data.deals) {
            setBestDeals(response.data.deals);
          }
          if (response.data.isVisible !== undefined) {
            setBestDealsVisible(response.data.isVisible);
          }
        }
        setBestDealsLoading(false);
      }).catch((error) => {
        console.error("Error fetching best deals:", error);
        setBestDealsLoading(false);
      });

      // Fetch Products
      getProducts({ limit: 10 }).then((response) => {
        if (response.success && response.data?.products) {
          setProducts(response.data.products);
        }
        setProductsLoading(false);
      }).catch((error) => {
        console.error("Error fetching products:", error);
        setProductsLoading(false);
      });
    };

    fetchAllData();
  }, []);

  return (
    <GlobalDataContext.Provider
      value={{
        categories,
        categoriesLoading,
        brands,
        brandsLoading,
        bestDeals,
        bestDealsVisible,
        bestDealsLoading,
        products,
        productsLoading,
      }}
    >
      {children}
    </GlobalDataContext.Provider>
  );
};
